/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2023-01-09 10:47:59
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-02-06 15:46:25
 * @FilePath: /wemeet-web-activity/src/pages/event/[eventid]/registration/buyer/hooks/useCoupon.ts
 * @Description: 优惠券处理hook
 */
import { Coupons } from '@quickService/PublicCouponQueryPublicList';
import dayjs from 'dayjs';
import { useState, useMemo } from 'react';
import update from 'immutability-helper';

export type CouponsExtend = Partial<
  Coupons[0] & {
    formatThreshold?: number;
    formatValue?: number;
    timeRange?: string;
    checked?: boolean; // 是否选中
  }
>[];

const formatTime = (time: number) => dayjs(time * 1000).format('YYYY.MM.DD');

class CouponList {
  // allCoupons: CouponsExtend; // 所有优惠券列表，包括是否领取的
  coupons: CouponsExtend;
  coupon: CouponsExtend[0] | undefined;
  setCoupons: any;
  private setCoupon: any;
  private flag: boolean;

  constructor() {
    this.coupons = [];
    this.flag = false;
    // this.allCoupons = [];
  }

  /**
   * 初始化设置并且格式化优惠券
   * 将优惠券分成可用和不可用的两种
   * @param coupons 优惠券列表
   * @returns coupons 格式化之后的coupons
   */
  setCouponList(coupons?: CouponsExtend) {
    const formatCoupon = useMemo(() => this.transformCoupons(coupons || []), []);
    const [reactCoupons, setReactCoupons] = useState(formatCoupon);
    const [reactCoupon, setReactCoupon] = useState<CouponsExtend[0]>();
    // const [reactAllCoupon, setReactAllCoupon] = useState([]);
    this.coupons = reactCoupons;
    this.setCoupons = setReactCoupons;
    this.coupon = reactCoupon;
    this.setCoupon = setReactCoupon;
    // this.allCoupons = reactAllCoupon;
    // this.setAllCoupons = setReactAllCoupon;

    return {
      coupons: reactCoupons,
      coupon: reactCoupon,
    };
  }

  /**
   * 格式化优惠券信息
   * @param coupons 优惠券列表
   * @returns coupons 格式化之后的优惠券列表
   */
  transformCoupons(coupons: CouponsExtend) {
    return coupons?.map?.((item) => ({
      ...item,
      formatThreshold: Number(item.threshold! / 100),
      formatValue: Number(item.coupon_value! / 100),
      timeRange: `${formatTime(item.begin_time!)}-${formatTime(item.end_time!)}`,
    }));
  }

  /**
   * 获取前三个优惠券
   * @returns coupons
   */
  getThreeCoupon() {
    return this.coupons.slice(0, 3);
  }

  /**
   * 获取最优惠的优惠券,已领取的优惠券才算
   * @param ticketPrice 门票价格
   * @returns coupons 最优惠的
   */
  getSuitableCoupon(ticketPrice: number, coupons?: CouponsExtend) {
    const allCoupons = coupons || this.coupons;
    const len = allCoupons.length;
    let i = 0;
    let bestCoupon;
    for (i; i < len; i++) {
      if (
        (allCoupons[i].user_coupon_state === 1 || allCoupons[i].user_coupon_state === 0) &&
        ticketPrice >= (allCoupons[i].threshold || 0)
      ) {
        if (
          !bestCoupon ||
          (bestCoupon && (bestCoupon?.coupon_value || 0) < (allCoupons[i]?.coupon_value || 0))
        ) {
          bestCoupon = allCoupons[i];
        }
      }
    }

    return bestCoupon;
  }

  /**
   * 更新单个优惠券的信息
   * @param coupon 优惠券
   */
  updateCoupon(coupon: CouponsExtend[0]) {
    const index = this.coupons.findIndex((item) => item.coupon_id === coupon.coupon_id);
    const nCouponList = update(this.coupons, {
      [index]: {
        $set: coupon,
      },
    });

    this.setCoupons(nCouponList);
  }

  /**
   * 跟进优惠券id获取优惠券
   * @param couponId 优惠券id
   * @param coupons 优惠券列表
   * @returns 选中的优惠券
   */
  getCouponByCouponId(couponId: string, coupons?: CouponsExtend) {
    const couponList = coupons || this.coupons;

    return couponList.find((item) => item.coupon_id === couponId);
  }

  /**
   * 设置选中优惠券
   * @param coupon 优惠券
   */
  updateSelectCoupon(coupon?: CouponsExtend[0]) {
    if (this.flag) {
      this.flag = false;
      return;
    }
    if (!coupon) {
      // 没有的话就是删除了
      const selectIndex = this.coupons.findIndex((item) => item.checked);
      if (selectIndex > -1) {
        const nCouponList = update(this.coupons, {
          [selectIndex]: {
            checked: {
              $set: false,
            },
          },
        });
        this.setCoupons(nCouponList);
      }
      this.setCoupon(undefined);
      return;
    }
    let nCoupon = coupon;
    if (!coupon.formatThreshold) {
      nCoupon = this.transformCoupons([coupon])?.[0];
    }
    this.setCoupon(nCoupon);

    if (this.coupons.length > 0) {
      this.updateCouponList(this.coupons, coupon);
    }
  }

  /**
   * 切换是否选中
   */
  toggleSelectedCoupon(coupon?: CouponsExtend[0], coupons?: CouponsExtend) {
    const selectIndex = this.coupons.findIndex((item) => item.checked);
    let nCouponList = coupons || this.coupons;
    let checked;
    if (selectIndex > -1) {
      nCouponList = update(this.coupons, {
        [selectIndex]: {
          checked: {
            $set: false,
          },
        },
      });
      checked = false;
    }
    if (coupon && !coupon.checked) {
      const index = nCouponList.findIndex((item) => item.coupon_id === coupon?.coupon_id);
      if (index > -1) {
        nCouponList = update(nCouponList, {
          [index]: {
            checked: {
              $set: true,
            },
          },
        });
        checked = true;
      }
    }
    this.setCoupons(nCouponList);

    return checked;
  }

  /**
   * 更新优惠券列表数据
   * @param coupons 优惠券列表
   * @param coupon 选中的优惠券
   */
  updateCouponList(coupons?: CouponsExtend, coupon?: CouponsExtend[0]) {
    // 有选中的优惠券的话，需要把列表也设置成选中的
    const selectCoupon = coupon || this.coupon;
    this.toggleSelectedCoupon(selectCoupon, coupons);
  }

  /**
   * 获取下单页显示的优惠券
   * @returns coupons 下单页显示的优惠券
   */
  getCanUseToBuyCoupons() {
    return this.coupons.filter((item) => item.user_coupon_state === 1);
  }

  setFlag(flag: boolean) {
    this.flag = flag;
  }
}

const couponList = new CouponList();

export default couponList;
